import styled, { css } from 'styled-components';

export const AppWrapper = styled.main`
.loadwrap {
	position: relative;
}

.custom-scroll {
	webkit-overflow-scrolling: touch;
	scrollbar-color:rgba(255, 255, 255, .5) rgba(0, 0, 0, .3);
	-ms-overflow-style : scrollbar;
	::-webkit-scrollbar {
			-webkit-appearance: none;
			width: 6px;
	}
	
	::-webkit-scrollbar-thumb {
			border-radius: 4px;
			background-color: rgba(0, 0, 0, .5);
			box-shadow: 0 0 1px rgba(255, 255, 255, .5);
	}
	::-webkit-scrollbar-track {
			background-color: rgba(0, 0, 0, .15)
	}
	::-webkit-scrollbar-thumb:hover {
			background: #555;
	}
}

`;
